import { Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import HomePage from "./pages/HomePage";
import MarketPage from "./pages/MarketPage";
import CreateMarketPage from "./pages/CreateMarketPage";
import MyBetsPage from "./pages/MyBetsPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="min-h-screen bg-canvas">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/market/:address" element={<MarketPage />} />
          <Route path="/create" element={<CreateMarketPage />} />
          <Route path="/my-predictions" element={<MyBetsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      <footer className="border-t border-gray-200 py-6 mt-12">
        <div className="container mx-auto px-4 text-center text-ink/50 text-sm">
          <p>EtherMarket — Prediction markets for DeFi &amp; TradFi</p>
          <p className="mt-1">Settled on Ethereum in USDT</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
